import * as yup from 'yup';

export const createParameterUnitSchema = yup.object({
  name: yup.string().required('Name is required'),
  code: yup.string().nullable(),
});

export const updateParameterUnitSchema = yup.object({
  id: yup.number().required('ID is required'),
  name: yup.string().required('Name is required'),
  code: yup.string().nullable(),
});
